import { Component, For, JSX } from "solid-js";
import { CivFlag } from "../../explorer/src/components/CivFlag";
import { GameScores, GameSummary } from "./parsing/types";

export type Score = {
  key: keyof GameScores;
  label: string;
  color?: string;
  icon?: string;
};

export type ScoreGroupingConfig = Record<string, Score[]>;

export const ScoreTable: Component<{ players: GameSummary[]; groups: ScoreGroupingConfig }> = (props) => {
  const groups = Object.keys(props.groups);
  const scores = Object.values(props.groups).flat();
  const maxScores = props.players.reduce((acc, player) => {
    Object.entries(player.scores).forEach(([key, value]) => (acc[key] = Math.max(acc[key] || 0, value)));
    return acc;
  }, {} as GameScores);

  function getBarStyle(score: number, key: Score["key"]): JSX.CSSProperties {
    const color = scores.find((s) => s.key === key)?.color ?? "grey";
    const width = `${(score / maxScores[key]) * 80}%`;
    return {
      background: `linear-gradient(to right, ${color}, ${color} ${width}, transparent ${width})`,
    };
  }

  return (
    <table class="text-left my-8 whitespace-nowrap min-w-full">
      <thead>
        <tr>
          <th></th>
          {groups.map((group) => (
            <th class="uppercase text-sm pr-4 text-gray-300" colSpan={props.groups[group].length}>
              {group}
            </th>
          ))}
        </tr>
        <tr>
          <th></th>
          {scores.map((score) => (
            <th class="text-gray-100 text-sm pr-2 font-normal pb-2">{score.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <For each={props.players}>
          {(player, index) => {
            return (
              <tr class="group">
                <td class="font-bold py-1 pl-4 pr-2 flex items-center text-gray-100 group-hover:text-white whitespace-nowrap">
                  <span style={{ background: player.color }} class="inline-block flex-none rounded-full w-2 h-2 mr-2"></span>
                  <a href={`https://aoe4world.com/players/${player.profileId}`} class="flex-auto">
                    {player.name}
                  </a>
                  {props.players.length > 2 && <span class="text-gray-400 text-sm ml-2">{player.teamName}</span>}
                  <CivFlag abbr={player.civ.abbr} class="w-6 mx-2 rounded-sm" />
                </td>
                {scores.map(({ key }) => (
                  <td class="pr-2 relative">
                    <div class="absolute inset-0 opacity-40 group-hover:opacity-60" style={getBarStyle(player.scores[key], key)} />
                    <span class="relative px-1">{player.scores[key]}</span>
                  </td>
                ))}
              </tr>
            );
          }}
        </For>
      </tbody>
    </table>
  );
};
